<template>
    <!-- order: posição visual = ordem de ativação (o 1º selecionado fica no topo com "Onde") -->
    <div :class="['fb-row', { 'is-disabled': disabled }]" :style="{ order: index }">
        <span v-if="index === 0" class="fb-row__prefix">Onde</span>
        <el-tag class="fb-row__prefix text-center" v-else type="info" size="small" effect="plain">E</el-tag>

        <!-- Campo -->
        <div class="fb-row__field">
            <i :class="icon"></i>
            <span class="fb-row__field-title">{{ title }}</span>

            <!-- Ícone de ajuda (só aparece com tooltip ligado e com conteúdo) -->
            <el-tooltip v-if="tooltip" :placement="tooltipPlacement" effect="dark">
                <div slot="content" class="fb-row__tooltip">
                    <slot name="tooltip">{{ tooltipText }}</slot>
                </div>
                <i class="el-icon-question fb-row__help"></i>
            </el-tooltip>
        </div>

        <!-- Operador (desabilitado por enquanto: ainda não é enviado ao backend) -->
        <el-select
            class="fb-row__operator"
            size="small"
            :value="operator"
            :disabled="operatorDisabled"
            :popper-append-to-body="false"
        >
            <el-option label="É" value="EQ"></el-option>
            <el-option label="Não é" value="NEQ"></el-option>
        </el-select>

        <!-- Valor (controle do filtro filho) -->
        <!-- Quando desabilitado, o tooltip também aparece ao passar o mouse sobre o campo -->
        <el-tooltip
            :disabled="!(disabled && tooltip)"
            :placement="tooltipPlacement"
            effect="dark"
        >
            <div slot="content" class="fb-row__tooltip">
                <slot name="tooltip">{{ tooltipText }}</slot>
            </div>
            <div class="fb-row__value">
                <slot />
            </div>
        </el-tooltip>

        <el-button
            class="fb-row__remove"
            type="text"
            icon="el-icon-delete"
            title="Remover condição"
            @click="$emit('remove')"
        />
    </div>
</template>

<script>
    import { Select, Option, Button, Tag, Tooltip } from 'element-ui';

    export default {
        name: 'FilterBuilderRow',
        props: {
            index: { type: Number, default: 0 },
            title: { type: String, required: true },
            icon: { type: String, default: '' },
            operator: { type: String, default: 'EQ' },
            // Quando for liberar Igual/Diferente, passe :operator-disabled="false"
            operatorDisabled: { type: Boolean, default: true },
            // Bloqueia a interação (o botão de remover continua ativo)
            disabled: { type: Boolean, default: false },
            // true = exibe o tooltip (o filho já valida se há texto/slot)
            tooltip: { type: Boolean, default: false },
            tooltipText: { type: String, default: '' },
            tooltipPlacement: { type: String, default: 'top' },
        },
        components: {
            [Select.name]: Select,
            [Option.name]: Option,
            [Button.name]: Button,
            [Tag.name]: Tag,
            [Tooltip.name]: Tooltip,
        },
    };
</script>

<style scoped>
    .fb-row {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 6px 0;
    }
    .fb-row__prefix {
        width: 40px;
        flex-shrink: 0;
        font-size: 13px;
        color: #909399;
    }
    .fb-row__field {
        display: flex;
        align-items: center;
        gap: 6px;
        width: 150px;
        flex-shrink: 0;
        height: 32px;
        padding: 0 10px;
        box-sizing: border-box;
        border: 1px solid #e4e7ed;
        border-radius: 6px;
        background: #fff;
        font-size: 13px;
        color: #303133;
    }
    .fb-row__field-title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .fb-row__operator {
        width: 96px;
        flex-shrink: 0;
    }
    .fb-row__value {
        flex: 1;
        min-width: 0;
    }
    .fb-row__help {
        margin-left: auto;
        flex-shrink: 0;
        color: #c0c4cc;
        cursor: help;
    }
    .fb-row__help:hover {
        color: #409eff;
    }
    .fb-row__tooltip {
        max-width: 260px;
        line-height: 1.4;
    }
    .fb-row.is-disabled .fb-row__field {
        background: #f5f7fa;
        color: #c0c4cc;
    }
    .fb-row__remove {
        color: #909399;
        padding: 0 4px;
    }
    .fb-row__remove:hover {
        color: #f56c6c;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/_micro/FilterBuilder/FilterBuilderRow.vue